import BaseService from "@/attributes/BaseService";
class SheetService extends BaseService {}

export default SheetService;
